import React from "react";
import PieCharts from "../Charts/PieChart/PieChart";
import AnalysisHeader from "./AnalysisHeader";
import AnalysisPagination from "./AnalysisPagination";

export default function AnalysisTypes({ AnalysisData }) {
  function TypesAnalysis(element, index) {
    switch (element.question_type) {
      case "single":
        return (
          <AnalysisHeader
            index={index}
            type={element.question_type}
            title={element.question_title}
            description={element.question_description}
            count={element.answer_count}
          >
            <PieCharts
              key={index}
              index={index}
              data={
                Array.isArray(element.analysis.result)
                  ? element.analysis.result
                  : []
              }
            />
          </AnalysisHeader>
        );
      
      case "boolean":
      return (
        <AnalysisHeader
          index={index}
          type={element.question_type}
          title={element.question_title}
          description={element.question_description}
          count={element.answer_count}
        >
          <PieCharts
            key={index}
            index={index}
            emoji={element.question_emoji}
            data={
              Array.isArray(element.analysis.result)
                ? element.analysis.result
                : []
            }
          />
        </AnalysisHeader>
      );

      case "score":
        return (
          <AnalysisHeader
            index={index}
            type={element.question_type}
            title={element.question_title}
            description={element.question_description}
            count={element.answer_count}
          >
            <PieCharts
              key={index}
              index={index}
              count={element.answer_count}
              data={
                Array.isArray(element.analysis.result)
                  ? element.analysis.result
                  : []
              }
              type={element.question_type}
              title={element.question_title}
              description={element.question_title}
            />
          </AnalysisHeader>
        );
      case "multi":
        return (
          <AnalysisHeader
            index={index}
            type={element.question_type}
            title={element.question_title}
            description={element.question_description}
            count={element.answer_count}
          >
            <PieCharts
              key={index}
              index={index}
              count={element.answer_count}
              data={
                Array.isArray(element.analysis.result)
                  ? element.analysis.result
                  : []
              }
              type={element.question_type}
              title={element.question_title}
              description={element.question_title}
            />
          </AnalysisHeader>
        );
      case "input":
        return (
          <AnalysisHeader
            index={index}
            type={element.question_type}
            title={element.question_title}
            description={element.question_description}
            count={element.answer_count}
          >
            <AnalysisPagination
              count={element.answer_count}
              data={
                Array.isArray(element.analysis.result)
                  ? element.analysis.result
                  : []
              }
            />
          </AnalysisHeader>
        );

      default:
        break;
    }
  }

  return (
    <div>
      {AnalysisData.map((element, index) => (
        <div key={index}>{TypesAnalysis(element, index)}</div>
      ))}
    </div>
  );
}
